<template>
  <div class="loading-animation " v-if="loading" ref="main_loading_block">
    <div class="spinner-container">
      <span class="loader_spinner"></span>
    </div>
  </div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style>
.loading-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;

  width: 100%;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner-border2 {
  width: 3rem;
  height: 3rem;
  margin-right: 0.5rem;


  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>
